import React from "react";

function CopyRights() {
  return (
    <div className="footer-copy-rights">
      <p>&copy; 2023 MIYABI HOUSE. All rights reserved.</p>
    </div>
  );
}

export default CopyRights;
